import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import icon_carbon from "../../../assets/icons/carbonemission_icon.png";
import icon_recycle from "../../../assets/icons/recycle_icon.png";
import icon_carbonreported from "../../../assets/icons/carbonreported_icon.png";
import icon_goals from "../../../assets/icons/goals_icon.png";
import info_icon from "../../../assets/icons/info_icon.png";
import {
  TEXT_CONSTANTS,
  DASHBOARD_CONSTANTS,
  DASH_CARDS
} from "../../../constants/Constants";
import DashCardWrapper from "../../../components/layout/card";
import axios from "axios";
import { 
  setRecyclePackaging, 
  setCarbonEmissionAvoided, 
  setSupplierSubmittedGoals,
  setCarbonReported
} from "../../../redux/slices/dashboardSlice";
import { useDispatch } from "react-redux";
import { API_BASE_URL } from "../../../services/apiService";

const SupplierDashBoard = () => {
  const [pagePermission, setPagePermission] = useState({});

  useEffect(() => {
    const permission = sessionStorage.getItem('UserPermission');
    console.log( permission);
    
      const parsedPermissions = JSON.parse(permission);
      console.log(parsedPermissions['SUPPLIER_DASHBOARD']);
      
      setPagePermission(parsedPermissions['SUPPLIER_DASHBOARD']);

  }, []);
  const dispatch = useDispatch();
  const emailId = sessionStorage.getItem("Email");
  const supplierId=sessionStorage.getItem("supplierId")
  const role=sessionStorage.getItem("Role")

  const [recyclePackagingState, setRecyclePackagingState] = useState({
    data: null,
    isLoading: true,
    error: null
  });

  const [carbonEmissionState, setCarbonEmissionState] = useState({
    data: null,
    isLoading: true,
    error: null
  });

  const [supplierGoalsState, setSupplierGoalsState] = useState({
    data: null,
    isLoading: true,
    error: null
  });
  const [carbonReportedState, setCarbonReportedState] = useState({
    data: null,
    isLoading: true,
    error: null
  });

  const fetchRecyclePackagingData = async () => {
    try {
      setRecyclePackagingState(prev => ({ ...prev, isLoading: true }));
      const response = await axios.post(
        `${API_BASE_URL}/dashboard/recyclePackaging/supplier/${emailId}`,
        {},
        {
          headers: {
            "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`,   
            "Content-Type": "application/json"
          }
        }
    );
      dispatch(setRecyclePackaging(response.data));
      setRecyclePackagingState({
        data: response.data,
        isLoading: false,
        error: null
      });
    } catch (error) {
      console.error("Error fetching recycle packaging data:", error);
      setRecyclePackagingState(prev => ({
        ...prev,
        isLoading: false,
        error: error.message || "Failed to fetch recycle packaging data"
      }));
    }
  };
  const fetchCarbonReportedData = async () => {
    try {
      setCarbonReportedState(prev => ({ ...prev, isLoading: true }));
      const response = await axios.get(
        `${API_BASE_URL}/dashboard/carbonReported`,
        {
          params: {
            supplierId: supplierId,
            currentYear: new Date().getFullYear()
          },
          headers: {
            "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`,
            "Content-Type": "application/json"
          }
        }
      );
      dispatch(setCarbonReported(response.data))
      setCarbonReportedState({
        data: response.data,
        isLoading: false,
        error: null
      });
    } catch (error) {
      console.error("Error fetching carbon reported data:", error);
      setCarbonReportedState(prev => ({
        ...prev,
        isLoading: false,
        error: error.message || "Failed to fetch carbon reported data"
      }));
    }
  };
  

  const fetchCarbonEmissionData = async () => {
    try {
      setCarbonEmissionState(prev => ({ ...prev, isLoading: true }));
      const response = await axios.post(
        `${API_BASE_URL}/dashboard/carbonEmissionAvoided/supplier/${emailId}`,
        {},
        {
          headers: {
            "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`,   
            "Content-Type": "application/json"
          }
        }
      );
      
      dispatch(setCarbonEmissionAvoided(response.data));
      setCarbonEmissionState({
        data: response.data,
        isLoading: false,
        error: null
      });
    } catch (error) {
      console.error("Error fetching carbon emission data:", error);
      setCarbonEmissionState(prev => ({
        ...prev,
        isLoading: false,
        error: error.message || "Failed to fetch carbon emission data"
      }));
    }
  };

  const fetchSupplierGoalsData = async () => {
    try {
      setSupplierGoalsState(prev => ({ ...prev, isLoading: true }));
      const response = await axios.post(
        `${API_BASE_URL}/dashboard/supplierSubmittedGoals/supplier/${emailId}`,
        {},
        {
          headers: {
            "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`,   
            "Content-Type": "application/json"
          }
        }
      );
      
      dispatch(setSupplierSubmittedGoals(response.data));
      setSupplierGoalsState({
        data: response.data,
        isLoading: false,
        error: null
      });
    } catch (error) {
      console.error("Error fetching supplier goals data:", error);
      setSupplierGoalsState(prev => ({
        ...prev,
        isLoading: false,
        error: error.message || "Failed to fetch supplier goals data"
      }));
    }
  };


  useEffect(() => {
    if (emailId) {
      fetchRecyclePackagingData();
    }
  }, [emailId]);

  useEffect(() => {
    if (emailId) {
      fetchCarbonEmissionData();
    }
  }, [emailId]);
   
  useEffect(()=>{
    if(emailId){
      fetchCarbonReportedData();
    }
  },[emailId]);

  useEffect(() => {
    if (emailId) {
      fetchSupplierGoalsData();
    }
  }, [emailId]);

  

  if(pagePermission===false){
    console.log(pagePermission);
    
    return <div>You do not have permission to access the Supplier Dashboard.</div>;
  }

  return (
    <div data-testid="dashboard" className="w-full p-6">
      <Card className="w-full bg-white relative mb-[20px] h-auto">
        <div className="flex items-center justify-between flex-col md:flex-row lg:flex-row gap-2">
          <div className="flex flex-col justify-start self-start">
            <span className="text-[18px] font-bold text-[#2C5778] m-0 ">
              {TEXT_CONSTANTS.DASHBOARD_TITLE}
            </span>
            <span className="text-[10px] font-bold text-[#2C5778] m-0 ">
              {TEXT_CONSTANTS.KPI_SUMMARY}
            </span>
          </div>
          {/* <div className="flex justify-center items-center">
            <Button
              type="primary"
              shape="round"
              icon={<DownloadOutlined />}
              onClick={handleDownloadExcel}
              size="60px"
              className="top-[3px] w-[175px] h-[43px] bg-[#1F405A]"
            >
              {TEXT_CONSTANTS.DOWNLOAD_BUTTON}
            </Button>
          </div> */}
        </div>
      </Card>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        <DashCardWrapper
          icon={icon_carbon}
          title={DASH_CARDS.CARBON_EMISSION_AVOIDED.TITLE}
          infoicon={info_icon}
          // fields={DASH_CARDS.CARBON_EMISSION_AVOIDED.FIELDS}
          carbonEmissionData={carbonEmissionState.data}
          isLoading={carbonEmissionState.isLoading}
          error={carbonEmissionState.error}
          role={role}
        />
        
        <DashCardWrapper
          icon={icon_recycle}
          title={DASH_CARDS.RECYCLE_PACKAGING.TITLE}
          infoicon={info_icon}
          fields={DASH_CARDS.RECYCLE_PACKAGING.FIELDS}
          recycleData={recyclePackagingState.data}
          isLoading={recyclePackagingState.isLoading}
          error={recyclePackagingState.error}
          role={role}
        />
        
        <DashCardWrapper
  icon={icon_carbonreported}
  title={DASH_CARDS.CARBON_REPORTED.TITLE}
  infoicon={info_icon}
  fields={DASH_CARDS.CARBON_REPORTED.FIELDS}
  carbonReportedData={carbonReportedState.data}
  isLoading={carbonReportedState.isLoading}
  error={carbonReportedState.error}
  role={role}
/>
        
        <DashCardWrapper
          icon={icon_goals}
          title={DASH_CARDS.SUPPLIERS_SUBMITTED_GOALS.TITLE}
          infoicon={info_icon}
          supplierSubmittedGoalsData={supplierGoalsState.data}
          isLoading={supplierGoalsState.isLoading}
          error={supplierGoalsState.error}
          role={role}
        />
      </div>
    </div>
  );
};

export default SupplierDashBoard;